import { createFileRoute } from '@tanstack/react-router';
import { PraisesFeed, praiseFeedSearchSchema } from '../../../features/praises';

function RouteComponent() {
  return <PraisesFeed />;
}

export const Route = createFileRoute('/_auth/_feed/praises')({
  validateSearch: praiseFeedSearchSchema,
  component: RouteComponent,
});
